export default __webpack_public_path__ + "static/media/whatsapp.891b193f.png";